//
// locales/glitch/uk.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/flavours/glitch/locales/uk';
import localeData from 'react-intl/locale-data/uk.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
